import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLicenseForm } from "../../../Hook/Licenses/useLicensesForm";
import Form from "../../../Components/Form/form";
import { FileEarmarkMedical, FileEarmarkLock } from "react-bootstrap-icons";

export default function LicenseForm({ show, handleClose, license, setReload }) {
    const { t } = useTranslation(); // Translation hook

    const {
        formLicense,
        setFormLicense,
        handleFormSubmit,
        handleFormCancel,
        contracts,
    } = useLicenseForm({
        license,
        onClose: handleClose,
        reload: setReload,
    });

    const formConfig = {
        submitText: t("common.actions.save"),
        sections: [
            {
                title: t("licenses.form.sections.basic-info"),
                icon: FileEarmarkLock,
                columns: 2,
                fields: [
                    {
                        name: "client.name",
                        label: t("licenses.form.field.client.label"),
                        type: "text",
                        disabled: true,
                    },
                    {
                        name: "application.name",
                        label: t("licenses.form.field.application.label"),
                        type: "text",
                        disabled: true,
                    },
                    {
                        name: "serial",
                        label: t("licenses.form.field.serial.label"),
                        type: "text",
                        disabled: true,
                    },
                    {
                        name: "status",
                        label: t("licenses.form.field.status.label"),
                        type: "select",
                        options: [
                            {
                                value: "",
                                label: t(
                                    "licenses.form.field.status.placeholder"
                                ),
                            },
                            {
                                value: "ACTIVE",
                                label: t("licenses.status.active"),
                            },
                            {
                                value: "INACTIVE",
                                label: t("licenses.status.inactive"),
                            },
                            {
                                value: "BLOCKED",
                                label: t("licenses.status.blocked"),
                            },
                        ],
                        required: true,
                        errorMessages: {
                            required: t(
                                "licenses.form.field.status.errors.required"
                            ),
                        },
                    },
                ],
            },
            {
                title: t("licenses.form.sections.contract-info"),
                icon: FileEarmarkMedical,
                columns: 2,
                fields: [
                    {
                        name: "contract.id",
                        label: t("licenses.form.field.contract.label"),
                        type: "select",
                        options: [
                            {
                                value: "",
                                label: t(
                                    "licenses.form.field.contract.placeholder"
                                ),
                            },
                            ...contracts.map((contract) => ({
                                value: contract.id,
                                label: contract.description,
                            })),
                        ],
                        required: true,
                        errorMessages: {
                            required: t(
                                "licenses.form.field.contract.errors.required"
                            ),
                        },
                    },
                    {
                        name: "expires_at",
                        label: t("licenses.form.field.expires-at.label"),
                        type: "date",
                    },
                ],
            },
        ],
        onSubmit: async () => {
            handleFormSubmit();
        },
        onCancel: () => handleFormCancel(),
        onChange: (newFormData) => {
            setFormLicense(newFormData);
        },
        data: formLicense,
    };
    return (
        <>
            <Modal
                show={show}
                size="lg"
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                centered
                aria-labelledby="example-modal-sizes-title-lg"
                className="modal-create-user"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{t("licenses.form.title")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form {...formConfig} />
                </Modal.Body>
            </Modal>
        </>
    );
}
